import React from 'react';
import { Link } from 'react-router-dom';
import { observer } from 'mobx-react';

// Helpers
import { toggleDrawer, confirm } from '../../helpers/helpers.js';
import { isAuthorized } from '@smarterservices/iam-react-client';

// Dependencies
import { FeatureFlag } from "react-launch-darkly";

// Translations
import translate from '../Translate.js';



// Components
import * as icons from '../Icons/Icons';
import Drawer from '../Drawer/Drawer';
import Toolbar from '../Common/Toolbar';

const Locations = observer(class Locations extends React.Component {
  constructor() {
    super();
    this.getLocations = this.getLocations.bind(this);
    this.deleteLocations = this.deleteLocations.bind(this);
    this.renderResults = this.renderResults.bind(this);

    this.state = {
      drawerOpen: false,
      drawerContent: null,
      locationSid: null,
      selectedRows: [],
    }
  }


  componentDidMount() {
    const { pathname } = this.props.routing.location;
    const { LocationStore, SessionStore } = this.props.store;
    const { proctorAccountSid } = SessionStore.userData;
    const iam = sessionStorage.getItem('iam');


    if(LocationStore.locations.length === 0) {
      this.getLocations();
    }
    if(pathname.indexOf('/edit') > -1) {
      const locationSid = pathname.substr(pathname.lastIndexOf('/') + 1);

      this.setState({
        locationSid: locationSid,
        drawerContent: "LocationEdit"
      });

      toggleDrawer(null, this, 'LocationEdit');
    } else if(pathname.indexOf('/add') > -1) {
      toggleDrawer(null, this, 'LocationEdit');
    } else if(pathname.indexOf('/schedule') > -1) {
      const scheduleLocationSid = pathname.substr(pathname.lastIndexOf('/') + 1);

      this.setState({
        scheduleLocationSid
      });

      toggleDrawer(null, this, 'ScheduleManage');
    }

    if (!isAuthorized('sp:CreateProctorAccountLocationAvailability', `ssrn:ss:sp::${proctorAccountSid}:location`, iam)) {
      this.props.routing.history.push('/unauthorized');
    }
  }

  getLocations() {
    const { LocationStore, ScheduleStore, SessionStore } = this.props.store;

    if(SessionStore.smarterscheduling) {
      const callback = () => {
        // Check if scheduling is enabled by getting account
        ScheduleStore.getScheduleAccount(ScheduleStore.getScheduleLocations);
      }

      LocationStore.getLocations(callback);
    } else {
      LocationStore.getLocations();
    }
  }

  handleEdit(e, locationSid) {
    e.preventDefault();

    // Reset location data
    this.setState({
      locationSid: null
    });
    this.props.store.LocationStore.resetLocation();

    // Update url
    let path = e.target.href.replace(/^(?:\/\/|[^\/]+)*\//, '').replace('#', '/');

    if(this.props.routing.location.pathname !== path) {
      this.props.routing.history.push(path);
    }
  }

  deleteLocations(location) {
    const _this = this;
    const { translation } = this.props;
    const { LocationStore } = this.props.store;

    LocationStore.locationSid = location.sid;

    const msg = {
      heading: translation.delete_confirm.heading_singular,
      body: translation.delete_confirm.body_singular,
      button: translation.delete_confirm.button
    }

    if(this.state.selectedRows.length > 1) {
      msg.heading = translation.delete_confirm.heading_plural.replace('%count%', this.state.selectedRows.length);
      msg.body = translation.delete_confirm.body_plural;
    }

    confirm(msg, () => {
      for(let i = 0; i < _this.state.selectedRows.length; i++) {
        LocationStore.deleteLocation(_this.state.selectedRows[i]);
      }

      _this.setState({
        selectedRows: []
      });

      // Uncheck checkboxes
      const cboxes = document.querySelectorAll('table input[type="checkbox"]:checked');
      cboxes.forEach(cbox => {
        cbox.checked = false;
      })

      // Refresh location list
      this.getLocations();
    });
  }

  enableSchedule(location) {
    const _this = this;
    const { ScheduleStore } = this.props.store;

    const callback = (data) => {
      _this.getLocations();
    }

    const data = {
      title: location.name,
      externalId: location.sid,
      seatManagement: 'basic',
      sid: location.sid
    }

    ScheduleStore.enableLocationSchedule(data, callback);
  }

  renderEditButton(location) {
    const { translation } = this.props;

    return (
      <Link
        className="btn--outline"
        to={`/locations/edit/${location.sid}`}
        onClick={(e) => {
          this.handleEdit(e, location.sid);
          this.setState({locationSid: location.sid});
          toggleDrawer(null, this, 'LocationEdit');
        }}
      >
        {translation.edit}
      </Link>
    )
  }

  renderScheduleButton(location) {
    const { translation } = this.props;
    const { scheduleLocations } = this.props.store.ScheduleStore;
    let scheduleEnabled = false;
    let scheduleSid = null;

    scheduleLocations.forEach(scheduleLocation => {
      if(scheduleLocation.externalId === location.sid) {
        scheduleEnabled = true;
        scheduleSid = scheduleLocation.sid;
      }
    });

    if(location.schedulingModule === 'smarter-scheduling') {
      if(scheduleEnabled) {
        // Return manage schedule button
        return (
          <Link
            className="btn--outline"
            to={`/locations/schedule/${scheduleSid}`}
            onClick={() => {
              this.setState({scheduleLocationSid: scheduleSid});
              toggleDrawer(null, this, 'ScheduleManage');
            }}
          >
            <icons.iconCalendar />
            {translation.manage_schedule}
          </Link>
        )
      } else {
        // Return enable schedule button
        return (
          <button
            className="btn--link"
            onClick={() => this.enableSchedule(location)}
          >
            {translation.enable_schedule}
          </button>
        )
      }
    }

    return null;
  }

  handleSelect(e, sid) {
    let selectedRows = [...this.state.selectedRows];
    let rowIndex = -1;

    if(e.target.checked) {
      selectedRows.push(sid);
    } else {
      rowIndex = selectedRows.indexOf(sid);
      selectedRows.splice(rowIndex, 1);
    }

    this.setState({
      selectedRows
    });
  }

  renderResults() {
    const { LocationStore, ScheduleStore, SessionStore } = this.props.store;
    const { translation } = this.props;

    if(!LocationStore.locations.length && !SessionStore.loading) {
      return (
        <div className="cta">
          <strong className="cta__copy">{translation.location_cta.heading}</strong>
          <Link className="cta__btn btn--icn-right" to="/locations/add" onClick={(e) => {
              this.handleEdit(e);
              toggleDrawer(null, this, 'LocationEdit');
            }}>
            {translation.location_cta.button}
            <icons.iconCircleRight className="icon" />
          </Link>
        </div>
      )
    } else if(LocationStore.locations.length > 0 && SessionStore.loadingCalls.indexOf('getScheduleLocations') < 0) {
      return (
        <table className="locations">
          <thead>
            <tr>
              <th id="heading-select" scope="col">
                <span className="meta">Select</span>
              </th>
              <th id="heading-name" scope="col">{translation.name}</th>
              <th id="heading-address" scope="col">{translation.address}</th>
              {ScheduleStore.scheduleAccountEnabled &&
                <th id="heading-actions" scope="col">{translation.actions}</th>
              }
            </tr>
          </thead>
          <tbody>
            {LocationStore.locations.map(
              (key, i) =>
              <tr key={i}>
                <td className="check-col" aria-labelledby="heading-select">
                  <input
                    id={`select-${key.sid}`}
                    className="checkbox-input"
                    type="checkbox"
                    onChange={(e) => this.handleSelect(e, key.sid)}
                  />

                  <label
                    className="checkbox-label checkbox-label--solo" htmlFor={`select-${key.sid}`}
                  >
                    <span className="meta">Select {key.hame}</span>
                  </label>
                </td>
                <td className="fn org" aria-labelledby="heading-name">
                  <h3>
                    <Link
                      to={`/locations/edit/${key.sid}`}
                      onClick={(e) => {
                        this.handleEdit(e, key.sid)
                        this.setState({locationSid: key.sid})
                        toggleDrawer(null, this, 'LocationEdit');

                      }}
                    >
                      {key.name}
                    </Link>
                  </h3>
                </td>
                <td aria-labelledby="heading-address">
                  <p className="adr">
                    <span className="street-address">{key.address1}<br/>{key.address2 || ''}</span>
                    <span className="locality">{key.place}</span>, <span className="region">{key.region}</span> <span className="postal-code">{key.postalCode}</span>
                    <span className="country">{key.country}</span>
                  </p>
                </td>
                <td className="actions" aria-labelledby="heading-actions">
                  <FeatureFlag
                    flagKey="proctor-schedules"
                    renderFeatureCallback={() => this.renderScheduleButton(key)}
                    renderDefaultCallback={() => this.renderEditButton(key)}
                  />
                </td>
              </tr>
            )}
          </tbody>
        </table>
      )
    }

    return null;
  }

  render() {
    const { translation } = this.props;

    return(
      <this.props.Validate>
        <main tabIndex="0" id="main-content" className="page">
          <div className="wrap">
            <header className="page__header">
              <div className="wrap">
                <h1 className="page__title">{translation.heading}</h1>

                <div className="page__actions actions">
                  <Link className="btn--outline" to="/locations/add" onClick={(e) => {
                    this.handleEdit(e)
                    toggleDrawer(null, this, 'LocationEdit');
                  }
                  }>
                    <icons.iconPlus />
                    {translation.add}
                  </Link>
                </div>
              </div>
            </header>

            {this.renderResults()}
          </div>

          {this.state.selectedRows.length > 0 &&
            <Toolbar
              selectedRows={this.state.selectedRows}
              deleteText={translation.delete}
              deleteFunction={this.deleteLocations}
              {...this.props}
            />
          }

          <Drawer
            content={this.state.drawerContent}
            isOpen={this.state.drawerOpen}
            parent={this} {...this.props}
            locationSid={this.state.locationSid}
            callback={this.getLocations}
          />
        </main>
      </this.props.Validate>
    )
  }
})

export default translate('Locations')(Locations);



// WEBPACK FOOTER //
// ./src/app/components/Locations/Locations.js